import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { SeekerJobPayment, SeekerJobPaymentPayerType, SeekerJobPaymentStatus } from 'src/app/common';
import { Utility } from 'src/app/core/common';
import { PersianDate } from 'src/app/core/persian-date';
import { KarpashaService } from 'src/app/services/karpasha.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-seeker-job-payment',
  templateUrl: './seeker-job-payment.component.html',
  styleUrls: ['./seeker-job-payment.component.scss']
})
export class SeekerJobPaymentComponent {
  constructor(private karpashaService: KarpashaService, private route: ActivatedRoute, private store: Store) { }

  PaymentStatus = SeekerJobPaymentStatus;
  PayerType = SeekerJobPaymentPayerType;
  current: any;
  isOperator: boolean;
  paymentCalculator: PaymentCalculator;
  showHelp: boolean;
  get isMainComponent() { return this.route.component == <any>this.constructor; }
  get link() { return `${environment.app.url}/karpasha/payment/${(this.seekerJob?.Id || this.paymentCalculator?.salary || '')}`; }

  @Input() salary: number;
  @Input() seekerJob: any;

  async ngOnInit() {
    this.current = this.store.selectSnapshot(state => state.auth.user);
    if (!this.isMainComponent)
      this.isOperator = this.current?.Operator?.Disabled === false || this.current?.Karpasha?.Disabled === false;
    if (!this.seekerJob) {
      var id = this.route.snapshot.params.id;
      if (!isNaN(id)) this.salary = id;
      else if (!!id)
        this.seekerJob = await this.karpashaService.getGuestSeekerJob(id);
    }

    this.paymentCalculator = new PaymentCalculator(
      this.seekerJob?.Job?.MaxSalary ||
      this.seekerJob?.Seeker?.Seeker.JobAlertSettings.MaxSalary ||
      this.seekerJob?.Job?.MinSalary ||
      this.seekerJob?.Seeker?.Seeker.JobAlertSettings.MinSalary ||
      this.salary);
  }

  async savePayments() {
    this.seekerJob.Payments = [
      ...(this.seekerJob.Payments || []),
      ...(this.paymentCalculator.payments || [])
    ].sort((a, b) => new Date(a.PaymentDate).getTime() - new Date(b.PaymentDate).getTime());
    await this.karpashaService.saveSeekerJob(this.seekerJob);
  }
  async removePayments() {
    this.seekerJob.Payments = this.seekerJob.Payments?.filter(_ => _.Status == SeekerJobPaymentStatus.Paid);
    await this.karpashaService.saveSeekerJob(this.seekerJob);
  }

  get PendingPayments() {
    return this.seekerJob?.Payments?.sort(
      (a, b) => new Date(a.PaymentDate).getTime() - new Date(b.PaymentDate).getTime()
    ).filter(_ => _.Status == SeekerJobPaymentStatus.Pending);
  }

  overdue(payment: any) {
    return payment.Status != SeekerJobPaymentStatus.Paid && new Date(payment.PaymentDate).getTime() < Date.now();
  }
}

export class PaymentCalculator {
  private baseSalary = 5600000;
  constructor(public salary?: number) {
    this.salary = salary || this.baseSalary;
  }
  date = new PersianDate().addMonth(1).toGregorian();
  deposit = 0;
  count = 5;
  month = 12;
  payerType = SeekerJobPaymentPayerType.Seeker;
  get total() {
    if (!(this.salary > 0)) return 0;
    if (this.month == 0) return this.salary * 0.08;
    var salary = this.salary * this.month / 12;
    return Math.min(salary, this.baseSalary) * 0.50 + Math.max(0, salary - this.baseSalary) * 0.30;
  }
  get amount() { return Math.floor((this.total - this.deposit) / this.count / 1000) * 1000; }
  get payments() {
    if (!this.amount) return [];
    return <SeekerJobPayment[]>new Array(this.count).fill(null).map((_, i) => {
      return { Amount: this.amount, PayerType: this.payerType, PaymentDate: new PersianDate(this.date).addMonth(i).toGregorian() };
    });
  }
  get paymentsTable() {
    var payments = this.payments;
    if (this.deposit > 0)
      payments.splice(0, 0, <SeekerJobPayment>{ _title: 'بیعانه', Amount: this.deposit });
    payments.push(<SeekerJobPayment>{ _title: 'جمع', Amount: Utility.sum(payments.map(_ => _.Amount)) });
    return payments;
  }
}
